import { AppState } from '../root.reducer';

export const getAccessToken = (state: AppState) => state.auth.token;
export const getCurrentRoute = (state: AppState) => state.auth.currentRoute;
